<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/6.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能宠物产品</h3>
            <p class="title-details">
              以科学、智能养宠为中心，依托音视频编码、AI智能分析、手机远程控制、云存储等技术，围绕宠物的吃、住、安全、健康等方面，为您的爱宠提供真正需要的智能产品。
            </p>
            <!-- <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src: 'static/video/Homevideosolutions.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>家用视频解决方案</span>
            </van-button> -->
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "喂食器",
          details: "",
          buttonList: [],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/product/P41920580KFeed.jpg"),
              articletitle: "小K可视喂食器",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light:
                        "分享快乐：一键下载萌宠趣味短视频，分享至微信、微博、抖音，朋友圈show起来。"
                    },
                    {
                      light:
                        "远程访问：APP远程访问实时查看，即使千里之外也能与爱宠零距离，实时视讯，看到就安心。"
                    },
                    {
                      light:
                        "云端存储：爱宠趣味视频云端存储，留下所有美好瞬间（独有宠物识别，快速定位录像）"
                    },
                    {
                      light:
                        "语音互动：远程语音通话，实时主人语音呼唤爱宠进食，想ta即刻呼唤ta"
                    },
                    {
                      light:
                        "远程投喂：远程定时投喂+一键投喂+定量投喂，出门在外也能让ta吃的饱饱的"
                    },
                    {
                      light:
                        "双重供电：停电时，启动备用电池供电，断电不断粮，保证小主子不挨饿（电池需自行购买，3节1号电池）。"
                    },
                    {
                      light:
                        "高清全景：高清超广类鱼眼视角，能看清家里的每一个角落，让ta无处可藏。"
                    },
                    {
                      light:
                        "结构精良：透明储食桶，食粮剩余多少一清二楚；搅粮片软胶设计，无卡粮担忧；内置独立干燥剂盒，配合干燥剂，干燥防潮，每一餐都是新鲜的；上下体分体设计，拆洗方便。"
                    }
                  ]
                }
                // {
                //   id: 3 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于商铺，住宅，街道，工厂，学校等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.yuncooltech.com/product.html"
            }
            // {
            //   id: 3 - 1 - 2,
            //   src: require("../assets/images/product/P42920580CFeed.jpg"),
            //   articletitle: "小C保鲜宠物喂食器",
            //   articledetails: "",
            //   traitList: [
            //     {
            //       id: 3 - 1 - 1 - 2,
            //       lightTitle: "产品特点",
            //       lightList: [
            //         {
            //           light:
            //             "语音录制：支持录制10秒语音播放，吸引爱宠靠近进食。 "
            //         },
            //         {
            //           light:
            //             "单独餐盒：5格单独餐盒设计，旋转出粮，干粮湿粮都适用。"
            //         },
            //         {
            //           light:
            //             "手机远程喂食：通过手机APP可远程设置定时定量喂食计划，科学养宠。"
            //         },
            //         {
            //           light: "规律饮食。也可通过APP一键即时投喂，为爱宠加餐。"
            //         },
            //         {
            //           light: "低温保鲜：0-8℃低温保鲜，原汁原味，锁住新鲜"
            //         },
            //         {
            //           light:
            //             "双供电系统，断电不断粮：断电启动备用电池供电，即使断电也能正常出粮。"
            //         }
            //       ]
            //     }
            //     // {
            //     //   id: 3 - 1 - 1 - 2,
            //     //   lightTitle: "适用场景",
            //     //   lightList: [
            //     //     {
            //     //       light:
            //     //         "广泛应用于商铺，住宅，街道，工厂，学校等多种监控应用场景"
            //     //     }
            //     //   ]
            //     // }
            //   ],
            //   have: false,
            //   href: "https://www.yuncooltech.com/product.html"
            // },
          ]
        },
        {
          id: 2,
          title: "喂水器",
          details: "",
          buttonList: [],
          articleList: [
            {
              id: 2 - 1 - 3,
              src: require("../assets/images/product/P43920580Fweater.jpg"),
              articletitle: "小方宠物喂水器",
              articledetails: "",
              traitList: [
                {
                  id: 3 - 1 - 1 - 3,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light:
                        "层层过滤净化，软化水质：过滤纤维棉+离子树脂+活性炭三层深度净化，让TA喝的每一口都清澈甘甜。"
                    },
                    {
                      light:
                        "静音水泵，舒适睡眠：采用低压静音水泵，工作噪音降至30dB以下，静享每一份安静。"
                    },
                    {
                      light:
                        "可视水位： 透明视窗设计，方便随时观察水量，及时加水。"
                    },
                    {
                      light:
                        "无水，不干烧：缺水时自动断电保护，防止水泵干烧，安全有保障。"
                    },
                    {
                      light:
                        "3L大容量，无需频繁加水：3L大容量，满足一周的饮水，出差旅行也无忧。"
                    },
                    {
                      light:
                        "花洒涌泉，循环活水：自然涌泉，花洒喷泉双出水，让出水更有趣。循环流动，让TA喝的每一口都是活水。"
                    }
                  ]
                }
                // {
                //   id: 3 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于商铺，住宅，街道，工厂，学校等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.yuncooltech.com/product.html"
            }
          ]
        },
        {
          id: 3,
          title: "摄像机",
          details: "",
          buttonList: [],
          articleList: [
            {
              id: 3 - 1 - 4,
              src: require("../assets/images/product/P44920580Tcamera.jpg"),
              articletitle: "小兔看护摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 3 - 1 - 1 - 4,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light:
                        "高清画质，全景视野：500万，180°全景高清镜头，画质清晰细腻，爱宠萌态一清二楚 "
                    },
                    {
                      light:
                        "动态追踪，抓拍分享：爱宠活动动态实时追踪，抓拍呆萌瞬间，分享好友。"
                    },
                    {
                      light:
                        "手机远程看护，动态实时掌握：通过手机APP可随时随地在线看护爱宠，查看爱宠动态。"
                    },
                    {
                      light:
                        "语音互动，贴心陪伴：远程语音喊话，随时随地和爱宠互动。也可选择内置的宠物声音或自定义录制声音进行播放，陪伴一刻也不能少。"
                    },
                    {
                      light:
                        "夜晚动态，清晰可见：超强红外夜视，即使黑夜也能看清它的一举一动。"
                    },
                    {
                      light:
                        "万能支架，安装灵活：可弯曲支架，安装随心所欲，支持挂墙、直立桌面、缠绕等安装方式。"
                    },
                    {
                      light: "超萌外形，可爱有趣：兔耳朵外形，灵动又有趣。"
                    }
                  ]
                }
                // {
                //   id: 3 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于商铺，住宅，街道，工厂，学校等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.yuncooltech.com/product.html"
            }
            // {
            //   id: 3 - 1 - 5,
            //   src: require("../assets/images/product/P45920580Pcamera.jpg"),
            //   articletitle: "大朋激光逗猫摄像机",
            //   articledetails: "",
            //   traitList: [
            //     {
            //       id: 3 - 1 - 1 - 5,
            //       lightTitle: "产品特点",
            //       lightList: [
            //         {
            //           light:
            //             "高清画质：高清镜头，画质清晰细腻，爱宠萌态一清二楚 "
            //         },
            //         {
            //           light:
            //             "激光逗猫：内置红外线激光探头，可以和爱宠随时随地互动，支持手动控制和自动控制激光红点，位置随意变换，增加互动乐趣"
            //         },
            //         {
            //           light:
            //             "动态追踪，抓拍分享：爱宠活动动态实时追踪，抓拍呆萌瞬间，分享好友。"
            //         },
            //         {
            //           light:
            //             "手机远程看护，动态实时掌握：通过手机APP可随时随地在线看护爱宠，查看爱宠动态。"
            //         },
            //         {
            //           light:
            //             "语音互动，贴心陪伴：远程语音喊话，随时随地和爱宠互动。也可选择内置的宠物声音或自定义录制声音进行播放，陪伴一刻也不能少。"
            //         },
            //         {
            //           light:
            //             "夜晚动态，清晰可见：超强红外夜视，即使黑夜也能看清它的一举一动。"
            //         },
            //         {
            //           light:
            //             "云台控制，全景视野：水平355°，垂直向上100°，向下10°云台控制旋转，视野广，可监控范围大"
            //         }
            //       ]
            //     }
            //     // {
            //     //   id: 3 - 1 - 1 - 2,
            //     //   lightTitle: "适用场景",
            //     //   lightList: [
            //     //     {
            //     //       light:
            //     //         "广泛应用于商铺，住宅，街道，工厂，学校等多种监控应用场景"
            //     //     }
            //     //   ]
            //     // }
            //   ],
            //   have: false,
            //   href: "https://www.yuncooltech.com/product.html"
            // }
          ]
        }
      ]
    };
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>
